import { render } from "./VehicleSearch.vue?vue&type=template&id=88f9895a"
import script from "./VehicleSearch.vue?vue&type=script&lang=js"
export * from "./VehicleSearch.vue?vue&type=script&lang=js"
script.render = render

export default script